import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageServiceService {
  readonly availableLanguages = ['en', 'ar', 'fr'];

  constructor() { }

  private normalizeLanguage(language: string | null): string {
    return language && this.availableLanguages.includes(language) ? language : 'en';
  }

  private currentLanguage = new BehaviorSubject<string>(this.normalizeLanguage(localStorage.getItem('language')));
  currentLanguage$ = this.currentLanguage.asObservable();

  private currentDirection = new BehaviorSubject<string>(
    this.normalizeLanguage(localStorage.getItem('language')) === 'ar' ? 'rtl' : 'ltr'
  );
  currentDirection$ = this.currentDirection.asObservable();

  private classToggle = new BehaviorSubject<boolean>(
    this.normalizeLanguage(localStorage.getItem('language')) === 'ar'
  );
  classToggle$ = this.classToggle.asObservable();

  changeLanguage(language: string) {
    const nextLanguage = this.normalizeLanguage(language);

    this.currentLanguage.next(nextLanguage);
    this.currentDirection.next(nextLanguage === 'ar' ? 'rtl' : 'ltr');
    localStorage.setItem('language', nextLanguage);
    this.classToggle.next(nextLanguage === 'ar');
  }

  toggleLanguage() {
    const currentIndex = this.availableLanguages.indexOf(this.currentLanguage.value);
    const newLanguage = this.availableLanguages[(currentIndex + 1) % this.availableLanguages.length];
    this.changeLanguage(newLanguage);
  }
}
